const findValueFromCookie = (key) => {
  const cookie = document.cookie;

  const keyValues = cookie.split(';').map((item) => {
    const array = item.split('=');
    return array.length ? { key: array[0].trim(), value: array[1] } : { key: undefined, value: undefined };
  });

  const target = keyValues.find((obj) => {
    return obj.key === key;
  });

  return target && target.value;
};

export const getSiteId = () => {
  return findValueFromCookie('SITE_ID');
};

export const getOtherSiteId = () => {
  return findValueFromCookie('OTHER_SITE_ID');
};

export const getCouponInfoFromCookie = () => {
  const siteId = findValueFromCookie('SITE_ID');
  const discountCode = findValueFromCookie('JP_WARIBIKI_CODE');
  const transactionId = findValueFromCookie('TRANSACTION_ID');

  return { siteId, discountCode, transactionId };
};

export const getCustomerCode = () => {
  return findValueFromCookie('W_CustomersCode');
};

const deleteCookie = (key, path) => {
  if (typeof document === 'undefined') return;
  const p = path || '/';
  // expires と Max-Age の両方を指定して確実に削除する
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; path=${p}`;
};

export const deleteDppErrorMessageCookie = () => {
  deleteCookie('DPP_ERROR_MESSAGE', '/');
};

export const getErrorMessageFromCookie = () => {
  const raw = findValueFromCookie('DPP_ERROR_MESSAGE');
  if (raw === undefined || raw === null) return raw;

  let decoded = raw;
  try {
    // URL エンコードされている cookie 値に対応（+ は空白相当として扱う）
    decoded = decodeURIComponent(String(raw).replace(/\+/g, '%20'));
  } catch (e) {
    decoded = raw;
  }

  return decoded;
};